import { render } from "./DesignTagCreationPanel.vue?vue&type=template&id=bc841118"
import script from "./DesignTagCreationPanel.vue?vue&type=script&lang=js"
export * from "./DesignTagCreationPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__